import { ValueTypeSwitcher } from 'legacy/lut/components/widgets/public/partner360/common/valueTypeSwitcher/ValueTypeSwitcher'
import { FC, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { getGlobalPartnerActualsTypes } from 'partner360/widgets/gp360Administration/helpers/getGlobalPartnerActualsTypes'

import { TRANSLATION_KEYS } from '../../../../translations'
import { CompletenessChart } from '../../../completenessChart'
import { ExportGlobalFinReport, FinancialsChart } from '../../../financialsChart'

import { IGlobalPartnerTableGraphsProps } from './models/globalPartnerTableGraphsProps'

import styles from './GlobalPartnerTableGraphs.module.scss'

export const GlobalPartnerTableGraphs: FC<IGlobalPartnerTableGraphsProps> = ({
  globalPartner,
  completenessChart,
  financialChart,
  onOpenPartnerDetails,
  valueType,
  onChangeValueType,
  fYear,
}) => {
  /** -------------------- Methods ----------------------- */
  const handleOpenPartnerDetails = useCallback(() => {
    onOpenPartnerDetails(globalPartner)
  }, [onOpenPartnerDetails, globalPartner])

  const onOpenGlobalPartnerPlan = useCallback(() => {
    window.open(`/page/jbl-hpscoutso-global/pid/${globalPartner.GlobalPartnerId}`, '_blank')
  }, [globalPartner.GlobalPartnerId])

  return (
    <div className={styles.root}>
      <div className={styles.buttonsControls}>
        <Button
          className={styles.openP360Plan}
          variant="outlined"
          onClick={onOpenGlobalPartnerPlan}
        >
          <Translation text={TRANSLATION_KEYS.globalPartnerExpanded.buttonsControls.openP360Plan} />
        </Button>
        <Button onClick={handleOpenPartnerDetails}>
          <Translation
            text={TRANSLATION_KEYS.globalPartnerExpanded.buttonsControls.openPartnerDetails}
          />
        </Button>
      </div>
      <div className={styles.graphsContainer}>
        <div className={styles.completenessContainer}>
          <CompletenessChart {...completenessChart} />
        </div>
        <div className={styles.financialsContainer}>
          <div className={styles.currencyButtons}>
            <ValueTypeSwitcher
              valueTypes={getGlobalPartnerActualsTypes(globalPartner.RTM)}
              valueType={valueType}
              onChangeValueType={onChangeValueType}
            />
            <ExportGlobalFinReport
              globalPartnerId={globalPartner.GlobalPartnerId}
              fYear={fYear}
              globalPartnerName={globalPartner.GlobalPartnerName}
            />
          </div>
          <FinancialsChart {...financialChart} />
        </div>
      </div>
    </div>
  )
}
